// types/zodToOpenaiJsonSchema.ts
import zodToJsonSchema from "zod-to-json-schema";
var moveRegexToDescription = (schema) => {
  if (!schema || typeof schema !== "object") {
    return schema;
  }
  if (Array.isArray(schema)) {
    return schema.map(moveRegexToDescription);
  }
  const newSchema = { ...schema };
  if (newSchema.pattern) {
    newSchema.description = newSchema.description ? `${newSchema.description} Pattern: ${newSchema.pattern}` : `Pattern: ${newSchema.pattern}`;
    delete newSchema.pattern;
  }
  ["anyOf", "oneOf", "allOf"].forEach((key) => {
    if (Array.isArray(newSchema[key])) {
      newSchema[key] = newSchema[key].map(moveRegexToDescription);
    }
  });
  if (newSchema.properties) {
    newSchema.properties = Object.entries(newSchema.properties).reduce(
      (acc, [key, value]) => ({
        ...acc,
        [key]: moveRegexToDescription(value)
      }),
      {}
    );
  }
  if (newSchema.items) {
    newSchema.items = moveRegexToDescription(newSchema.items);
    if (newSchema.items.properties) {
      newSchema.items.properties = Object.entries(
        newSchema.items.properties
      ).reduce(
        (acc, [key, value]) => ({
          ...acc,
          [key]: moveRegexToDescription(value)
        }),
        {}
      );
    }
  }
  return newSchema;
};
var zodToOpenaiJsonSchema = (schema, name, definitions) => {
  const jsonSchema = zodToJsonSchema(schema, {
    definitions
  });
  const cleanedSchema = moveRegexToDescription(jsonSchema);
  return {
    type: "json_schema",
    json_schema: {
      name,
      strict: true,
      schema: cleanedSchema
    }
  };
};

export {
  zodToOpenaiJsonSchema
};
